/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlsListData {
    getFixupPrototypeFunction() { return ControlsListData.fixupPrototype; }

    static newInstance(model: Partial<ControlsListData>): ControlsListData {
        let obj = Object.assign(new ControlsListData(), model);
        ControlsListData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlsListData>): ControlsListData {
        if (!model) return null;
        return ControlsListData.newInstance(<ControlsListData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlsListData) {
        if (!obj) return;

        models.ControlsListData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlsListData): boolean {
        Object.setPrototypeOf(obj, ControlsListData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count_of_status === undefined) {
            this.count_of_status = 0;
        }
        if (this.policy_mappings === undefined) {
            this.policy_mappings = 0;
        }
    }

    /**
     * attributes of controls which dictate actions specific to corestack
     */
    control_action_attributes: any;

    /**
     * the count of assessed service accounts for the control
     */
    count_of_status: number;

    /**
     * the unique identifier of the control in the tenant
     */
    compliance_control_uri: string;

    /**
     * attributes associated with the controls unique to the standard
     */
    control_attributes: any;

    /**
     * count of policies mapped to the control
     */
    policy_mappings: number;

    /**
     * the compliance standard associated with the control
     */
    compliance_uri: string;

    /**
     * current audit status of the control
     */
    audit_status: string;

    /**
     * unique DB id of the control
     */
    id: any;

}
